module.exports = __webpack_public_path__ + "img/signup-brick.042e6588.png";